"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disclaimer = void 0;
const stitches_config_1 = require("../../../stitches.config");
const Markdown_1 = require("./Markdown");
exports.Disclaimer = (0, stitches_config_1.styled)(Markdown_1.Markdown, {
    p: {
        margin: "0px",
    },
    strong: {
        fontWeight: 500,
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzY2xhaW1lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL2NvbXBvbmVudHMvQ29tbW9uL19fc3R5bGVzX18vRGlzY2xhaW1lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw4REFBa0Q7QUFDbEQseUNBQXNDO0FBRXpCLFFBQUEsVUFBVSxHQUFHLElBQUEsd0JBQU0sRUFBQyxtQkFBUSxFQUFFO0lBQ3pDLENBQUMsRUFBRTtRQUNELE1BQU0sRUFBRSxLQUFLO0tBQ2Q7SUFDRCxNQUFNLEVBQUU7UUFDTixVQUFVLEVBQUUsR0FBRztLQUNoQjtDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHN0eWxlZCB9IGZyb20gXCIuLi8uLi8uLi9zdGl0Y2hlcy5jb25maWdcIjtcbmltcG9ydCB7IE1hcmtkb3duIH0gZnJvbSBcIi4vTWFya2Rvd25cIjtcblxuZXhwb3J0IGNvbnN0IERpc2NsYWltZXIgPSBzdHlsZWQoTWFya2Rvd24sIHtcbiAgcDoge1xuICAgIG1hcmdpbjogXCIwcHhcIixcbiAgfSxcbiAgc3Ryb25nOiB7XG4gICAgZm9udFdlaWdodDogNTAwLFxuICB9LFxufSk7XG4iXX0=